var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87543 3.02775C3.75687 2.99254 3.63123 2.9908 3.51179 3.02274C3.39235 3.05467 3.28356 3.11908 3.19693 3.20915C3.1103 3.29922 3.04906 3.4116 3.01968 3.5344C2.9903 3.6572 2.99387 3.78585 3.03003 3.90674L5.25034 11.2987H13.0251C13.2067 11.2987 13.3808 11.3726 13.5093 11.5041C13.6377 11.6356 13.7098 11.814 13.7098 12C13.7098 12.186 13.6377 12.3644 13.5093 12.4959C13.3808 12.6274 13.2067 12.7013 13.0251 12.7013H5.25034L3.03003 20.0933C2.99387 20.2141 2.9903 20.3428 3.01968 20.4656C3.04906 20.5884 3.1103 20.7008 3.19693 20.7909C3.28356 20.8809 3.39235 20.9453 3.51179 20.9773C3.63123 21.0092 3.75687 21.0075 3.87543 20.9722C9.91461 19.1734 15.6096 16.3317 20.7149 12.5695C20.8031 12.5045 20.875 12.419 20.9246 12.32C20.9741 12.221 21 12.1113 21 12C21 11.8887 20.9741 11.779 20.9246 11.68C20.875 11.581 20.8031 11.4955 20.7149 11.4305C15.6096 7.66831 9.91462 4.82655 3.87543 3.02775V3.02775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/send-arrow.6eb02f7e9afe6f4c5337cde51196c1d0.svg";
export { ForwardRef as ReactComponent };